'use client'
import React from 'react';
import styles from './Footer.module.scss';
//import { useRouter } from 'next/router';
import { FaArrowUp, FaFacebookF } from 'react-icons/fa6';
import Link from 'next/link';

const Footer: React.FC = () => {
    //const router = useRouter();

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <footer className={styles.footerWrapper}>
            <div className={styles.overlay} />
            <div className={styles.footerContent}>
                <div className={styles.links}>
                    <Link href="/contact" legacyBehavior>
                        <a className={styles.link}>Contactez-nous</a>
                    </Link>
                    <Link href="https://www.facebook.com/lisaseror" legacyBehavior>
                        <a target="https://www.facebook.com/lisaseror" rel="noopener noreferrer" className={styles.link}>
                            <FaFacebookF className={styles.icon} />
                        </a>
                    </Link>
                    <Link href="/cgu-cgv" legacyBehavior>
                        <a target="_blank" rel="noopener noreferrer" className={styles.link}>CGU</a>
                    </Link>
                    <Link href="/" legacyBehavior>
                        <a className={styles.link}>Accueil</a>
                    </Link>
                </div>
                <div className={styles.bottomBar}>
                    <a
                        href="https://hestia-innovation.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.link}
                    >
                        Hestia Innovation © {new Date().getFullYear()} - Tous droits réservés
                    </a>
                    <button onClick={scrollToTop} className={styles.scrollTopButton}>
                        <FaArrowUp className={styles.icon} />
                    </button>
                </div>
            </div>
        </footer>
    );
};

export default Footer;